import { router } from "@smakecloud/api-client-helper";
import { basicSettings } from "./basic-settings";

export const settings = router({
    basicSettings,
});
